// Generated by `pnpm gen:svg` from src/assets/svg — do not edit.
import type { SVGProps } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
  ref?: Ref<SVGSVGElement>;
}
const SvgMustache = ({
  title,
  titleId,
  ref,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    id="Vrstva_1"
    data-name="Vrstva 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="308 218 220 220"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <defs>
      <style>{`
.mu-1 {
  stroke: #fff;
  stroke-width: 0.25px;
}

.mu-1,
.mu-2,
.mu-3 {
  stroke-miterlimit: 10;
}

.mu-4,
.mu-3 {
  fill: #fff;
}

.mu-5 {
  fill: #484747;
}

.mu-6 {
  fill: #f39ee5;
}

.mu-2,
.mu-3 {
  stroke: #000;
  stroke-width: 0.5px;
}

.mu-7 {
  fill: var(--mascot-accent, #ff49a4);
  opacity: 0.4;
}
`}</style>
    </defs>
    <path
      className="mu-4"
      d="M523.12,326.49c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.98.66-1.97,1.31-2.98,1.93-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path
      className="mu-7"
      d="M523.12,326.49c0,35.48-17.52,66.86-44.39,85.97-.73.52-1.48,1.04-2.23,1.54-.05.03-.09.06-.14.09-.98.66-1.97,1.31-2.98,1.93-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.24-.17-.5-.32-.74-.5-28.26-18.9-46.88-51.12-46.88-87.68,0-58.22,47.2-105.43,105.42-105.43s105.43,47.21,105.43,105.43Z"
    />
    <path d="M495.44,375.99c.59-1.9-6.85-11.22-12-17.52-5.16-6.28-10.69-13.2-16.28-18.6-2.29-2.22-5.62-5.26-8.73-8.03-.68-.64-1.35-1.24-2-1.82-2.16-1.91-4.04-3.57-5.21-4.6-.78-.69-1.23-1.09-1.23-1.09,0,0-1.42,12.53-.72,18.09.02.17.04.32.08.49.77,5.53,2.98,12.91,7.16,17.93.73.86,1.46,1.65,2.24,2.4.46.43.94.88,1.43,1.29.45.4.98.8,1.53,1.22.71.57,1.43,1.09,2.17,1.63.11.06.22.15.33.24.29.21.56.41.86.62,1.62,1.14,3.26,2.3,4.92,3.63.24.18.48.37.71.57.28.24.54.46.79.68,5.35,4.64,12.89,11.93,14.83,11.24,1.96-.7,8.55-6.45,9.13-8.37Z" />
    <path d="M341,375.99c-.59-1.9,6.85-11.22,12-17.52,5.16-6.28,10.69-13.2,16.28-18.6,2.29-2.22,5.62-5.26,8.73-8.03.68-.64,1.35-1.24,2-1.82,2.16-1.91,4.04-3.57,5.21-4.6.78-.69,1.23-1.09,1.23-1.09,0,0,1.42,12.53.72,18.09-.02.17-.04.32-.08.49-.77,5.53-2.98,12.91-7.16,17.93-.73.86-1.46,1.65-2.24,2.4-.46.43-.94.88-1.43,1.29-.45.4-.98.8-1.53,1.22-.71.57-1.43,1.09-2.17,1.63-.11.06-.22.15-.33.24-.29.21-.56.41-.86.62-1.62,1.14-3.26,2.3-4.92,3.63-.24.18-.48.37-.71.57-.28.24-.54.46-.79.68-5.35,4.64-12.89,11.93-14.83,11.24-1.96-.7-8.55-6.45-9.13-8.37Z" />
    <path
      className="mu-4"
      d="M476.5,414s-.09.06-.14.09c-.98.66-1.97,1.31-2.98,1.93-13.76,8.58-29.64,14.08-46.68,15.51-2.97.26-5.97.39-9.01.39-1.48,0-2.96-.03-4.43-.1-19.6-.8-37.81-6.96-53.22-17.06-.04-.02-.09-.05-.13-.08-.01,0-.01-.01-.02-.01-.96-7.27-.81-14.92.7-22.77,1.23-6.39,2.65-12.66,4.3-18.72.82-3.04,1.7-6.02,2.64-8.94.03-.12.07-.24.11-.36,4.34-13.48,9.89-25.51,16.85-34.75.66-.87,1.33-1.72,2.01-2.54.06-.07.12-.14.17-.21.68-.81,1.38-1.6,2.08-2.35,8.07-8.69,17.81-13.87,29.48-13.92h.16c12.48,0,22.95,5.65,31.49,15.21.34.38.67.76,1,1.15,7.82,9.2,13.96,21.72,18.54,36.18,1.17,3.7,2.24,7.53,3.19,11.46,1.41,5.73,2.6,11.68,3.58,17.79,1.22,7.62,1.25,15.04.31,22.1Z"
    />
    <path
      className="mu-2"
      d="M469.11,362.65c-9.07,18.55-28.59,31.38-51.2,31.38s-41.27-12.28-50.58-30.15c9.86-30.64,25.97-53.77,50.75-53.77s41.37,21.96,51.03,52.54Z"
    />
    <path
      className="mu-1"
      d="M454.17,318.1s.07-.01.07-.01c-4.88,15.38-15.36,25.4-18.68,36.43-4.42,14.68-5.76,29.79-7.01,31.15-2.52,2.7-17.58,2.7-20.92,0-1.68-1.37-1.17-15.69-6.17-28.73-5.69-14.78-6.5-16.98-13.81-28.32.01-.03.03-.07.07-.1-4.42-6.74-10.64-19.26-10.64-30.65,0-25.48,18.19-46.13,40.61-46.13s40.61,20.65,40.61,46.13c0,7.27-1.48,14.14-4.13,20.24Z"
    />
    <g>
      <path
        className="mu-6"
        d="M386.96,312.74c1.31-.54,2.19-1.08,2.72-2.38.53-1.3.27-2.3-.3-3.59-.57-1.29-1.97-2.49-3.17-3.01-1.2-.52-2.03-.7-3.32-.46-1.29.23-3.29,1.5-3.78,2.82-.48,1.32-.27,2.3.3,3.59.57,1.29,1.58,2.37,3.17,3.01,1.59.64,3.07.56,4.38.02Z"
      />
      <path
        className="mu-6"
        d="M448.14,312.7c-1.32-.51-2.21-1.03-2.77-2.33-.55-1.29-.31-2.29.23-3.6.54-1.3,1.92-2.53,3.11-3.07,1.19-.54,2.02-.74,3.31-.53,1.29.21,3.32,1.44,3.83,2.75.51,1.31.31,2.29-.23,3.6-.54,1.3-1.53,2.4-3.11,3.07-1.57.67-3.06.62-4.38.11Z"
      />
    </g>
    <path
      className="mu-5"
      d="M394.8,260.74c-4.07,3.34-7.89,7.45-10.62,12.25-3.56-1.71-7.23-4.06-7.76-6.53-.97-4.57,1.01-9.33,3.9-11.28,2.89-1.95,5.46-2.03,8.85-1.17,1.65.41,3.84,3.6,5.63,6.73Z"
    />
    <path
      className="mu-5"
      d="M459.29,266.46c-.53,2.47-4.71,4.82-8.26,6.53-2.73-4.79-5.89-8.04-9.96-11.38,1.79-3.13,3.82-7.18,5.47-7.6,3.39-.87,5.96-.78,8.85,1.17,2.89,1.95,4.86,6.71,3.9,11.28Z"
    />
    <path
      className="mu-3"
      d="M392.69,291.54c.09-5.45-4.28-9.94-9.75-10.03-5.47-.09-9.98,4.27-10.07,9.72-.09,5.45,4.28,9.94,9.76,10.03,5.47.09,9.98-4.27,10.07-9.72Z"
    />
    <path d="M383.73,299.67c4.47.69,8.27-3.09,7.59-7.54-.43-2.77-2.7-5.03-5.47-5.46-4.47-.69-8.27,3.09-7.59,7.54.43,2.77,2.7,5.03,5.47,5.46Z" />
    <path
      className="mu-3"
      d="M462.07,291.54c.09-5.45-4.28-9.94-9.76-10.03-5.47-.09-9.98,4.27-10.07,9.72-.09,5.45,4.28,9.94,9.75,10.03,5.47.09,9.98-4.27,10.07-9.72Z"
    />
    <path d="M449.09,299.32c4.47.69,8.27-3.09,7.58-7.55-.43-2.77-2.7-5.03-5.47-5.46-4.47-.69-8.27,3.09-7.58,7.55.43,2.77,2.7,5.03,5.47,5.46Z" />
    <path
      className="mu-4"
      d="M440.75,323.03c.39-.16,1.55-.64,3.09-.56.28.02,1.12.08,2.26.52,3.69,1.42,5.68,4.88,6.25,6.22.23.54.47,1.21.47,1.21.15.35.32.83.47,1.41.13.51.35,1.6.27,2.96,0,0-.12,1.85-1.01,3.73-1.4,2.96-5.03,6.25-9.71,7.15-1.78.34-3.75.1-7.7-.38-2.83-.35-4.73-.62-7.11-1.46-1.53-.54-4.52-1.6-6.63-3.96-3.93-4.4-2.68-10.94-2.44-12.1,5.59,1.26,9.01,3.48,11.12,5.31,1.53,1.33,2.4,2.47,4.8,4.06,2.19,1.45,4.71,3.07,7.96,2.88.82-.05,2.71-.18,4.44-1.52.79-.61,1.29-1.28,1.6-1.75.11-.19.25-.47.39-.82.49-1.25.43-2.33.38-3.3-.05-.87-.14-2.23-.9-3.75-.28-.57-.58-1.01-.81-1.31-.22-.26-.54-.6-.98-.93-.67-.5-4.7-2.17-7.26-.17-.25.2-.95.75-1.37,1.73-.28.65-.32,1.23-.35,1.62-.06.63-.02,1.24.13,1.74.12.4.31,1.24.96,1.98,1.01,1.16,2.44,1.33,2.86,1.37-.26.11-.65.25-1.15.3-1.66.15-3.2-.89-4.01-2.1-.21-.32-.49-.82-.67-1.51,0-.02,0-.05-.01-.09-.07-.5-.13-1.23-.02-2.1.34-2.61,2.06-5.29,4.68-6.39Z"
    />
    <path
      className="mu-4"
      d="M396.05,323.03c-.39-.16-1.55-.64-3.09-.56-.28.02-1.12.08-2.26.52-3.69,1.42-5.68,4.88-6.25,6.22-.23.54-.47,1.21-.47,1.21-.15.35-.32.83-.47,1.41-.13.51-.35,1.6-.27,2.96,0,0,.12,1.85,1.01,3.73,1.4,2.96,5.03,6.25,9.71,7.15,1.78.34,3.75.1,7.7-.38,2.83-.35,4.73-.62,7.11-1.46,1.53-.54,4.52-1.6,6.63-3.96,3.93-4.4,2.68-10.94,2.44-12.1-5.59,1.26-9.01,3.48-11.12,5.31-1.53,1.33-2.4,2.47-4.8,4.06-2.19,1.45-4.71,3.07-7.96,2.88-.82-.05-2.71-.18-4.44-1.52-.79-.61-1.29-1.28-1.6-1.75-.11-.19-.25-.47-.39-.82-.49-1.25-.43-2.33-.38-3.3.05-.87.14-2.23.9-3.75.28-.57.58-1.01.81-1.31.22-.26.54-.6.98-.93.67-.5,4.7-2.17,7.26-.17.25.2.95.75,1.37,1.73.28.65.32,1.23.35,1.62.06.63.02,1.24-.13,1.74-.12.4-.31,1.24-.96,1.98-1.01,1.16-2.44,1.33-2.86,1.37.26.11.65.25,1.15.3,1.66.15,3.2-.89,4.01-2.1.21-.32.49-.82.67-1.51,0-.02,0-.05-.01-.09-.07-.5-.13-1.23-.02-2.1.34-2.61,2.06-5.29,4.68-6.39Z"
    />
  </svg>
);
export { SvgMustache };
